export default "__VITE_ASSET___mCf9KBR__"